// hooks/useGlobalAlert.js
import { useAlert } from "react-alert";

let globalAlert = null;

export const useGlobalAlert = () => {
  const alert = useAlert();
  globalAlert = alert;
  return alert;
};

export const showGlobalAlert = (message, options = {}) => {
  if (!globalAlert) {
    console.warn("Alert not initialized. Using fallback.");
    window.alert(message);
    return;
  }
  globalAlert.removeAll?.();
  globalAlert.show(message, {
    timeout: 3000,
    ...options,
  });
};
